import { AppointmentBooker } from '@/shared/appointments/appointment-booker';
import { AppointmentClient } from '@/shared/appointments/appointment-client';
import { AppointmentOutcome } from '@/shared/appointments/appointment-outcome';
import { AppointmentReason } from '@/shared/appointments/appointment-reason';
import { ClientAccount } from '@/shared/clients/client-account';
import { LocationType } from '@/shared/location-type';

export interface Appointment {
    id?: string | null;
    originalAppointmentId?: string | null;
    interactionId?: string | null;
    appointmentTypeId: string | null;
    partnerPracticeId: string | null;
    partnerPracticeAddressId: string | null;
    legalAdvisorId: string | null;
    date: string | Date | null;
    locationType: LocationType | null;
    addressLine1: string | null;
    addressLine2: string | null;
    addressLine3: string | null;
    town: string | null;
    county: string | null;
    postcode: string | null;
    notes: string | null;
    sendConfirmationEmail: boolean;
    sendConfirmationLetter: boolean;
    sendReminderSms: boolean;
    booker?: AppointmentBooker;
    outcome: AppointmentOutcome | null;
    clients: Array<AppointmentClient>;
    reasons: Array<AppointmentReason>;
    isRebooked?: boolean;
    isSimpsonsSolicitors?: boolean;
    version?: number | null;
    createdDate?: string | Date | null;
    createdBy?: string | null;
    lastModifiedDate?: string | Date | null;
    lastModifiedBy?: string | null;

}

export function createAppointmentBooking(client: ClientAccount): Appointment {
    return {
        clients: new Array<AppointmentClient>(...[{ ...client }]),
        appointmentTypeId: null,
        partnerPracticeId: client.isAcquisition ? null : client.partnerPracticeId!,
        partnerPracticeAddressId: null,
        legalAdvisorId: null,
        date: null,
        locationType: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        town: null,
        county: null,
        postcode: null,
        notes: null,
        sendConfirmationEmail: false,
        sendConfirmationLetter: false,
        sendReminderSms: false,
        outcome: null,
        reasons: new Array<AppointmentReason>(),
    };
}
